import { createContext, useState, useEffect } from "react";
import { supabase } from "./auth";

export const Context = createContext();

export const ContextProvider = ({ children }) => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const urls = {
    discordBotInviteURL:
      "https://discord.com/oauth2/authorize?client_id=997285387175202966&permissions=0&integration_type=0&scope=bot",
    fishcordServerInviteURL: "https://discord.gg/BsCvg3Z23k",
  };
  const [user, setUser] = useState(null);
  const [session, setSession] = useState(null);
  const [accessToken, setAccessToken] = useState(null);

  useEffect(() => {
    const fetchData = async (accessToken, provider_token) => {
      try {
        const response = await fetch(`${apiBaseUrl}/api/user`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`, // Supabase JWT in header
          },
          body: JSON.stringify({ discord_access_token: provider_token }),
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user");
        }
        const userData = await response.json();
        setUser(userData);
      } catch (error) {
        console.error("Error updating user:", error);
      }
    };

    async function loadSession() {
      const { data } = await supabase.auth.getSession();
      setSession(data.session);
      setAccessToken(data.session?.access_token || null);

      const access_token = data.session?.access_token;
      const provider_token = data.session?.provider_token;

      if (data.session?.access_token) fetchData(access_token, provider_token);
    }

    loadSession();

    const { data: listener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        setSession(session);
        setAccessToken(session?.access_token || null);
        if (event === "SIGNED_OUT") window.location.href = "/";
      }
    );

    return () => listener.subscription.unsubscribe();
  }, [apiBaseUrl, accessToken]);

  return (
    <Context.Provider value={{ urls, user, session, accessToken }}>
      {children}
    </Context.Provider>
  );
};
